// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"qGOTTJuA","Breadcrumbs--small":"CaVhiulH","Item":"_SebCbUH","Arrow":"oRewZS72","IsActive":"acIGpM5O"};